export enum PageGateTypes {
  ageGate = 'ageGate',
  nbaIdGate = 'nbaIdGate',
  contactCollection = 'contactCollection'
}
